module.exports = __webpack_public_path__ + "img/logo_shopify.129cf3e9.svg";